export const firebaseConfig = {
  apiKey: "AIzaSyAFWS3IZnsfoZZJImlLogESr6WR1f1zbzs",
  authDomain: "tinbin-5baa7.firebaseapp.com",
  databaseURL: "https://tinbin-5baa7.firebaseio.com",
  projectId: "tinbin-5baa7",
  storageBucket: "tinbin-5baa7.appspot.com",
  messagingSenderId: "863307478466"
};



// WEBPACK FOOTER //
// ./src/firebase/config.js